// extracted by mini-css-extract-plugin
export default {"pictureCard":"Ygzv7WCb00bNpDXm88CQ"};